import styled from 'styled-components';

const ContainerStyled = styled.div`
  max-width: 100%;
  padding: 15px 15px 20px 15px;
  background: white;

  h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #2d1441;
    max-width: 160px;
    margin: auto;
    margin-top: 25px;
  }

  p {
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #2d1441;
    max-width: 200px;
    margin: auto;
    margin-bottom: 80px;
  }

  picture {
    z-index: 1;
    text-align: center;
    max-width: 95px;
    height: 92px;

    svg {
      margin: 50px auto 40px;
      display: block;
    }
  }
`;

export default ContainerStyled;
